import HeroImage from '../assets/images/blog/LIveChat.png';
import Post1 from '../assets/images/blog/ales.png';
import Post2 from '../assets/images/blog/alexander.png';
import Post3 from '../assets/images/blog/distel.png';
import Post4 from '../assets/images/blog/knight.png';
import Post5 from '../assets/images/blog/rodion.png';
import Post6 from '../assets/images/blog/simon.png';
import Post7 from '../assets/images/blog/kotliarskyi.png';
import Post8 from '../assets/images/blog/this.png';
import User1 from '../assets/images/blog/griffin.svg';
import User2 from '../assets/images/blog/julian.png';
import User3 from '../assets/images/blog/diego.png';
import User4 from '../assets/images/blog/cesar.png';



const images = {
    HeroImage, 
    Post1,
    Post2,
    Post3,
    Post4,
    Post5,
    Post6,
    Post7,
    Post8,
    User1,
    User2,
    User3,
    User4,
}

export default images